
import ButtonFavorite from '@/components/button/ButtonFavorite.ts';
import { Component, Mixins, Prop } from 'vue-property-decorator';

@Component
export default class ButtonFavoriteRemove extends Mixins(ButtonFavorite) {
  @Prop({default: true})
  private isEditMode!: boolean;
}
